import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class HeaderService {
	private readonly _toggleHeader$ = new BehaviorSubject<boolean>(true);

	get toggleHeader$(): Observable<boolean> {
		return this._toggleHeader$.asObservable();
	}

	setToggleHeader(toggleHeader: boolean): void {
		this._toggleHeader$.next(toggleHeader);
	}
}
